import React from 'react'
import img2034 from '../components/images/ietsy.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2034} alt='etsy' />

            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Etsy Global Account Management Overview
                    </h2>
                    <p>Elevate your global presence on Etsy with our specialized account management services designed to boost your shop’s visibility and sales. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services We Offer:</h3>
                <li><b>•	Product Listing:</b>Enhance visibility with beautifully crafted product listings. </li>
                <li><b>•	Advertising Campaign:</b>Maximize reach and ROI with targeted ad strategies. </li>
                <li><b>•	Promotion:</b> Drive sales with effective promotional campaigns. </li>
                <li><b>•	Category Approval:</b> Ensure accurate product categorization for maximum exposure.</li>
                <li><b>•	Account Health:</b> Maintain a healthy seller account to avoid penalties.</li>
                <li><b>•	Order Processing:</b>Streamline order management for quick and efficient fulfillment. </li>
                <li><b>•	Payment Reconciliation:</b> Ensure accurate and timely payment processing. </li>
                <li><b>•	Keyword Optimization:</b> Improve search rankings with strategic keyword placement. </li>
                <li><b>•	Safety Compliance:</b>Ensure product safety and compliance with Etsy standards. </li>
                <li><b>•	Basic Training:</b>Equip your team with essential Etsy knowledge and best practices. </li>
                <li><b>•	Sales Boost:</b> Implement strategies to significantly increase sales and reach.</li>
            </ul>
        </>
    )
}

export default events